export const HOTEL_TABS_LABELS = {
  DESCRIPTION: 'Description',
  REVIEWS: 'Reviews',
  AMENITIES: 'Amenities',
  POLICIES: 'Hotel Policies',
};
